import { HTMLProps, ReactNode } from 'react'

export enum EButtonType {
  CONTAINER = 'CONTAINER',
  PLAIN = 'PLAIN',
}

export interface IButtonBaseProps
  extends Omit<HTMLProps<HTMLButtonElement>, 'ref' | 'as' | 'type'> {
  /**
   * Whether svgs should be filled with color of text in button
   */
  fillSvg?: boolean
  /**
   * icon to display on left side of button
   */
  iconLeft?: ReactNode
  /**
   * icon to display on right side of button
   */
  iconRight?: ReactNode
  /**
   * Type of button component
   */
  viewType?: EButtonType
  /**
   * Whether button should be fullWidth
   */
  isBlock?: boolean
  /**
   * Whether button has loading indicator instead of iconLeft
   */
  isLoading?: boolean
  /**
   * button as link or button
   * @default 'button'
   */
  element?: 'button' | 'a'
  /**
   * Type of button
   */
  type?: 'button' | 'submit' | 'reset'
}

export type IButtonProps = IButtonBaseProps

export type ITertiaryButtonProps = Omit<IButtonProps, 'viewType'>
